"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.forEach = exports.map = exports.isObject = exports.isArray = exports.isContainer = void 0;
const JSON_1 = require("./JSON");
Object.defineProperty(exports, "isContainer", {
  enumerable: true,
  get: function () {
    return JSON_1.isContainer;
  }
});
Object.defineProperty(exports, "isArray", {
  enumerable: true,
  get: function () {
    return JSON_1.isArray;
  }
});
Object.defineProperty(exports, "isObject", {
  enumerable: true,
  get: function () {
    return JSON_1.isObject;
  }
});
const map_1 = require("./map");
Object.defineProperty(exports, "map", {
  enumerable: true,
  get: function () {
    return map_1.map;
  }
});
const forEach_1 = require("./forEach");
Object.defineProperty(exports, "forEach", {
  enumerable: true,
  get: function () {
    return forEach_1.forEach;
  }
});